<template>
  <div v-if="visible" ref="confirm" class="cp-confirm mobile">
    <div class="box-mask">
      <div class="box-container" :class="{hasChance: hasChance, hasBigPrize: hasBigPrize}">
        <div class="prize"></div>
        <div class="prize-wrapper">
          <Prize
            v-for="(item, index) in prize"
            :key="index"
            :prize="item.icon"
            :name="item.name || item.title"
            :class="`prize prize-${index + 1}`"
          >
          </Prize>
        </div>
        <div class="button">
          <div class="bottom-item confirm" @click="handleAction('yes')"></div>
          <div class="bottom-item cancel" @click="handleAction('cancel')"></div>
        </div>
        <Close is-mobile @close="handleAction('cancel')" class="close"></Close>
      </div>
    </div>
  </div>
</template>

<script>
import Prize from "~/components/Prize/index.vue";
import Close from '~/components/Close/close.vue';
// import { mapState } from "vuex";
export default {
  name: 'Confirm',
  components: {Prize, Close},
  data() {
    return {
      visible: false,
      prize: [],
      prizeList: {list: []},
      promiseStatus: null
    }
  },
  computed: {
    hasChance() {
      let hasChance = !this.prizeList || !this.prizeList.list || this.prizeList.list.length < 180
      return hasChance
    },
    hasBigPrize() {
      return this.prizeList && this.prizeList.list && this.prizeList.list.some(x => x.icon === 31)
    }
  },
  methods: {
    confirm() {
      let _this = this;
      this.visible = true;
      return new Promise(function(resolve, reject) {
        _this.promiseStatus = { resolve, reject };
      });
    },
    handleAction(action) {
      this.$refs.confirm.className += ' fadeOut';
      let t = setTimeout(() => {
        this.visible = false;
        clearTimeout(t);
        if (action === 'yes') {
          this.promiseStatus && this.promiseStatus.resolve('ok');
        } else {
          this.promiseStatus && this.promiseStatus.reject('cancel');
        }
      }, 300);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cp-confirm{
    text-align: center;
    color: #2c3e50;
    height: 100%;
    font-size: .32rem;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index 2001
    top 0
    animation fadeIn 0.3s ease-in-out
    &.fadeOut {
      animation fadeOut 0.3s ease-in-out
      animation-fill-mode forwards
    }
    .box-mask{
      z-index: 900;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .box-container {
    position absolute
    width 6.66rem
    height 8.62rem
    top 50%
    left 0.42rem
    margin-top -4.305rem
    background-image url('./images/modal.png') // 只能领一次
    background-size: 6.66rem 7.92rem;
    background-repeat: no-repeat;
    background-position 0 0
    animation fadeIn 0.3s ease-in-out
    &.hasBigPrize { // 只能领一次
      background-image url('./images/modal.png')
    }
    &.hasChance {
      background-image url('./images/modal1.png') // 还有机会
      &.hasBigPrize {
        background-image url('./images/modal1.png') // 还有机会
      }
    }
    .prize-wrapper {
      margin 2.2rem 0 0 0.48rem
      position relative
      display flex
      flex-wrap wrap
    }
    .button {
      width 5.05rem
      height 0.8rem
      margin: 0.46rem auto 0
      .bottom-item {
        width 2.32rem
        height 0.86rem
        background-image url('./images/confirm.png')
        background-size: 100% 100%
        background-repeat: no-repeat;
        display inline-block
        &.cancel {
          margin-left 0.39rem
          width 2.34rem
          height 0.89rem
          background-image url('./images/cancel.png')
        }
      }
    }
  }
  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
</style>
